<template>
    <div id="page">

        <div class="page-content">
            <div class="page-title page-title-small">
                <h2>
                    <!--<button @click.prevent="goBack"><i class="fa fa-arrow-right"></i></button>-->
                    پیام ها
                    <!--<button data-menu="notificationHelp" class="position-static mr-1"><i class="fa fa-question-circle helpIco"></i></button>-->
                </h2>
                <button type="button" @click.prevent="DeleteSelected" class="bg-fade-gray1-dark shadow-xl d-flex align-items-center justify-content-center DeleteSelectedNotif-btn"><i class="fa fa-trash"></i></button>
                <button class="bg-fade-gray1-dark shadow-xl d-flex align-items-center justify-content-center refresh-btn" @click.prevent="reloadPage"><i class="font-16 fa fa-redo"></i></button>
                <button data-menu="menu-main" class="bg-fade-gray1-dark shadow-xl d-flex align-items-center justify-content-center menu-main-btn"><i class="fa fa-bars"></i></button>
            </div>
            <div class="card header-card shape-rounded" data-card-height="100">
                <div class="card-overlay bg-highlight opacity-95"></div>
                <div class="card-overlay dark-mode-tint"></div>
            </div>

            <div class="ml-3 mr-3 mb-2 alert alert-small rounded-s shadow-xl bg-green1-dark" role="alert">
                <span><i class="fa fa-check"></i></span>
                <strong>شما {{NewListCount}}  پیام خوانده نشده دارید!</strong>
                <button type="button" class="close color-white opacity-60 font-16" data-dismiss="alert" aria-label="Close">×</button>
            </div>
            <div class="card card-style mb-2" v-for="n in notificationList" :key="n.notificationId" :class="{'bg-yellow1-light': n.status==false}">
                <div class="list-group list-custom-small list-icon-0">
                    <div class="p-3">
                        <div>
                            <div class="d-flex align-items-center mb-2">
                                <input class="form-check-input deleteCheckbox" type="checkbox" :value="n.notificationId" :id="n.notificationId">
                                <label class="text-muted mx-3 pr-3 mb-0" :for="n.notificationId">
                                    حذف
                                </label>
                            </div>
                            <div>
                                <i class="fa fa-calendar ml-3" :class="{'text-white': n.status==false,'text-warning': n.status==true}"></i>
                                <span class="text-muted ltr">{{n.registerDateTime}}</span>
                                <button class="btn" @click="deleteNotif(n)" style="float:left;margin-left:-15px;"><i class="fa fa-trash color-red1-light font-14 ml-0"></i></button>
                            </div>
                            <div @click.prevent="openDetails(n)">
                                <div>
                                    <i class="fa fa-check color-red1-dark ml-3"></i>
                                    <span class="font-weight-bold text-dark">{{n.subject}}</span>
                                </div>
                                <p class="text-justify mb-2">{{n.description}}</p>
                            </div>

                        </div>
                    </div>

                </div>
            </div>
            <div class="card card-style" v-if="loading">
                <div class="content">
                    <div class="d-flex justify-content-center w-100 py-5">
                        <div class="spinner-border color-magenta2-dark" role="status"></div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import VueSimpleAlert from "vue3-simple-alert";
    export default {
        data() {
            return {
                page: 1,
                filterId: 0,
                searchKey:"",
                pageLoaded: false,
                notificationList: [],
                loading:false
            };
        },
        computed: {
            NewListCount() {
                return this.$store.getters.GetNotificationCount;
            }
        },
        created() {
            console.log("created");
        },
        methods: {
            DeleteSelected() {
                VueSimpleAlert.confirm("آیا مایل به حذف این پیام هستید؟", null, "question", { confirmButtonText: "تایید", cancelButtonText: "انصراف" }).then(() => {

                    let ids = [];

                    var elements = document.getElementsByClassName('deleteCheckbox');

                    for (var i = 0; i < elements.length; i++) {
                        if (elements[i].checked)
                            ids.push(elements[i].value);
                    }
                    this.$http.post("NoticeMassageUser/DeleteSeleced", ids).then(
                        (response) => {
                            console.log(response);
                            var res = response.data;
                            if (res.isSuccess) {
                                this.showSuccessMessage("با موفقیت حذف شد.");
                                this.GetNotificationList();
                            } else {
                                this.showErrorMessage(res.message);
                            }

                        },
                        (data) => {
                            console.log(data);
                        }
                    );
                });
            },
            GetNotificationList() {
                this.loading = true;
                this.$http.get("Account/GetNotificationList", {
                   
                }).then(data => {
                    this.loading = false;
                    this.notificationList = data.data;
                });
            },
            GetNotifCount() {
                this.$store.dispatch("GetNotificationCountFromServer");
            },
            openDetails(n) {
                this.$http.get("Account/SeenNotification?id=" + n.notificationId);
                this.$router.push(n.linkUrl.replace("/tsk", "").replace("/TSK", ""));
            },
            deleteNotif(n) {
               VueSimpleAlert.confirm("آیا مایل به حذف این پیام هستید؟", null, "question", { confirmButtonText: "تایید", cancelButtonText: "انصراف" }).then(() => {
                    this.$http.get("Account/DeleteNotif?id=" + n.notificationId)
                        .then(data => {
                            var res = data.data.toString();
                            if (res=="1") {
                                this.showSuccessMessage("با موفقیت حذف شد.");
                                this.$router.go();

                            }
                            else {
                                this.showErrorMessage(res);
                            }


                        });
                });
            },
			pauseAllVid() {
				document.querySelectorAll('video').forEach(vid => vid.pause());
			},
        },
        mounted() {
			document.querySelectorAll(".menu-box-right").forEach(a => a.style.display = "block");

            this.GetNotifCount();
            this.GetNotificationList();
			
		}
    };
</script>
